import { setPusherLoading } from "@/store";
import { pusherCallback } from "@/utils";
import Pusher from "pusher-js";
import { v7 as uuidv7 } from 'uuid';
import { store } from "../redux";
import { getCustomBaseUrl, getCustomHeadersObject } from "@/utils/developer-settings";
import { ENVIRONMENT_KEYS, getEnvironmentValue } from "@/utils/get-environment-value";

const channelNamePrefix = getEnvironmentValue(ENVIRONMENT_KEYS.VITE_PUSHER_CHANNEL_NAME_PREFIX, '') || '';

let pusher: any

let channel: any

let timeoutId: any = null

export const startInactivityCheck = () => {
  timeoutId = window.setTimeout(() => {
    if (pusher) {
      pusher.disconnect()
    }
  }, 15 * 60 * 1000) // called after 15 minutes
}

// called by something that detects user activity
export const userActivityDetected = () => {
  if (timeoutId !== null) {
    window.clearTimeout(timeoutId)
  }
  // startInactivityCheck()
}

export const bindToChannelEvent = (eventName: string, customCallback?: () => void) => {
  const callback = typeof customCallback === 'function' ? customCallback : pusherCallback
  if (channel) {
    channel.bind(eventName, callback)
  }
}

export const unbindFromChannelEvent = (eventName: string) => {
  if (channel) {
    channel.unbind(eventName)
  }
}

export const unsubscribeChannel = (userId: string) => {
  if (pusher) {
    pusher.unsubscribe(`${channelNamePrefix}-${userId}`)
  }
}

export const disconnectFromPusher = () => {
  if (pusher) {
    pusher.disconnect()
    pusher = null
    channel = null
  }

  // clearing the idle state timeout
  userActivityDetected()
}

export const initRealTime = (dependentFunc = () => { }) => {

  const userId = JSON.parse(localStorage.getItem('auth') || '')?.user_id
  store.dispatch(setPusherLoading(true))
  // creating pusher instance
  if (!pusher) {
    const customBaseUrl = getCustomBaseUrl();
    const customHeaders = getCustomHeadersObject();
    const authEndpoint = `${customBaseUrl}/admin/api/pusher/authenticate`;

    pusher = new Pusher(getEnvironmentValue(ENVIRONMENT_KEYS.VITE_PUSHER_APP_KEY, '') || '', {
      cluster: getEnvironmentValue(ENVIRONMENT_KEYS.VITE_PUSHER_APP_CLUSTER, '') || '',
      // encrypted: true,
      authEndpoint,
      channelAuthorization: {
        endpoint: authEndpoint,
        headers: {
          'x-omniful-platform': 'web',
          'x-omniful-correlation-id': uuidv7(),
          Authorization: `Bearer ${JSON.parse(localStorage.getItem('auth') || '')?.access_token}`,
          ...customHeaders
        },
        transport: 'ajax'
      },
    })

    // subscribing to the channel
    channel = pusher.subscribe(`${channelNamePrefix}-${userId}`)

    // starting the inactivity timer
    startInactivityCheck()

    channel.bind("pusher:subscription_succeeded", () => {
      store.dispatch(setPusherLoading(false))
      dependentFunc()
    })
  
    pusher.connection.bind('message', (msg: any) => {
      if (!msg.channel && msg.event !== 'pusher:pong') {
        store.dispatch(setPusherLoading(false))
        dependentFunc()
        disconnectFromPusher()
      }
    })
  } else {
    store.dispatch(setPusherLoading(false))
    dependentFunc()
  }
}
